<template>
	<div class="variant-select">
		<button
			v-for="item in props.data"
			:key="item.value"
			class="variant-select__item transition-all flex-center"
			:class="{
				'variant-select__item--active': selectedValue === item.value,
			}"
			@click="selectedValue = item.value"
		>
			{{ item.label }}
		</button>
	</div>
</template>

<script setup>
import { computed } from "vue";

const props = defineProps({
	modelValue: String | Number,
	data: {
		type: Array,
		default: () => [],
	},
});

const emit = defineEmits(["update:modelValue"]);

const selectedValue = computed({
	get() {
		return props.modelValue;
	},
	set(newValue) {
		emit("update:modelValue", newValue);
	},
});
</script>
